import { PostCard } from "@/components/community/PostCard"
import { PostCardSkeletonList } from "@/components/common/skeletons"
import { Post } from "@/types/community.types"

interface PostsListProps {
  posts: Post[];
  loading: boolean;
  onPostUpdate: () => Promise<void>;
}

export function PostsList({
  posts,
  loading,
  onPostUpdate,
}: PostsListProps) {
  if (loading) {
    return <PostCardSkeletonList count={3} />;
  }

  if (posts.length === 0) {
    return (
      <p className="text-center text-gray-500">
        Nenhum post encontrado. Seja o primeiro a se apresentar!
      </p>
    )
  }

  return (
    <div className="space-y-4">
      {posts.map((post) => (
        <PostCard
          key={post.id}
          post={post}
          onLikeChange={onPostUpdate}
          onPostDelete={onPostUpdate}
        />
      ))}
    </div>
  )
}
